module.exports = __webpack_public_path__ + "img/buddy_antenna-05.54c9cf75.svg";